// Material UI Custom Shapes: https://material-ui.com/customization/default-theme/
module.exports = {
  borderRadius: 3,
  borderRadiusSubtle: 2,
};
